// extracted by mini-css-extract-plugin
export default {"volumeContainer":"volumeContainer_volumeContainer__li+xA","volumeBar":"volumeContainer_volumeBar__O0uuN"};